import { useState } from "react";
import { toast } from "sonner";
import { MessageSquare, Send, Trash2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { fmtShort, hmWIB, dateWIB } from "../lib/fmt";

export default function Comments({ report, comments = [], canComment, meId, onChanged }) {
  const [text, setText] = useState("");
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!comments.length && !canComment) return null;
  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.post(`/reports/${report.id}/comments`, { text });
      setText("");
      setOpen(false);
      toast.success("Komentar terkirim ke pemilik laporan");
      onChanged();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const del = async (id) => {
    try {
      await api.delete(`/comments/${id}`);
      onChanged();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="mt-3 space-y-2" data-testid={`comments-${report.id}`}>
      {comments.map((c) => (
        <div key={c.id} data-testid={`comment-${c.id}`} className="rounded-xl border-l-4 border-brand bg-brand-soft px-3 py-2 text-sm">
          <div className="flex items-center justify-between gap-2 text-xs text-[#7a6667]">
            <span><b className="text-brand-deep">{c.authorName}</b> · {fmtShort(dateWIB(c.createdAt))} {hmWIB(c.createdAt)}</span>
            {c.authorId === meId && (
              <button data-testid={`comment-delete-${c.id}`} onClick={() => del(c.id)} aria-label="Hapus komentar" className="p-1 text-brand"><Trash2 size={13} /></button>
            )}
          </div>
          <p className="mt-0.5 whitespace-pre-line">{c.text}</p>
        </div>
      ))}
      {canComment && !open && (
        <button data-testid={`comment-open-${report.id}`} onClick={() => setOpen(true)} className="inline-flex min-h-[40px] items-center gap-1.5 text-xs font-bold text-brand-deep">
          <MessageSquare size={14} /> Beri komentar
        </button>
      )}
      {canComment && open && (
        <div className="flex gap-2">
          <input data-testid={`comment-input-${report.id}`} className="field flex-1" placeholder="Tulis komentar…" value={text}
            onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} />
          <button data-testid={`comment-send-${report.id}`} disabled={busy} onClick={send} className="btn-primary px-4" aria-label="Kirim"><Send size={15} /></button>
        </div>
      )}
    </div>
  );
}
